import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { CONSTANTS } from '../../constants';

@Injectable({
  providedIn: 'root'
})
export class ThreadService extends ApiService {

  public list(data: any) {
    return this.getQueryParams(CONSTANTS.API.THREAD.GET_THREADS, data);
  }
  public add(data: any) {
    return this.post(CONSTANTS.API.THREAD.ADD_THREAD, data);
  }
  public stop(data: any) {
    return this.getQueryParams(CONSTANTS.API.THREAD.STOP_THREAD, data);
  }
  public start(data: any) {
    return this.getQueryParams(CONSTANTS.API.THREAD.START_THREAD, data);
  }
  public update(data: any) {
    return this.post(CONSTANTS.API.THREAD.UPDATE_THREAD, data);
  }
  public deleteThread(data: any) {
    return this.getQueryParams(CONSTANTS.API.THREAD.DELETE_THREAD, data);
  }
  public action(data: any) {
    return this.post(CONSTANTS.API.THREAD.THREAD_ACTION, data);
  }
  public updateDName(data: any) {
    return this.post(CONSTANTS.API.THREAD.THREAD_UPDATE_DNAME, data);
  }
}
